import { httpRequest } from "../../http";

import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";

export class CommandListAds {
  async run(folderId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/?folder_id=${folderId}`;
    try {
      const response = await httpRequest<any>(url, { method: "GET" });

      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
  deserialize(data: any): Ad[] {
    return new AdSerializer().deserializeList(data);
  }
}
